import React from 'react';
import useSlippageToleranceInput from 'src/components/TradeForm/SlippageToleranceInput/hooks/useSlippageToleranceInput';
import TradeFormCollapsible from 'src/components/TradeForm/TradeFormCollapsible';
import { SlippageToleranceInputProps } from 'src/components/TradeForm/SlippageToleranceInput/types';
import ControlledSlippageToleranceInput from 'src/components/TradeForm/SlippageToleranceInput/ControlledSlippageToleranceInput';

const CollapsibleSlippageToleranceInput = ({
	className,
	optionsClassName,
	hideCustom,
	hideDynamic,
	disabled,
	slippageTolerance: slippageToleranceFromProps,
	updateHandler,
	slippageValue: slippageValueFromProps,
}: SlippageToleranceInputProps) => {
	const {
		isCurrentDynamic,
		currentValue,
		handleCustomInputChange,
		handleBlur,
		handleFocus,
		handlePresetClick,
		customInputValue,
		isCustomInputFocused,
		presetOptions,
		dynamicSlippageString,
	} = useSlippageToleranceInput({
		slippageToleranceFromProps,
		slippageValueFromProps,
		updateHandler,
		hideDynamic,
	});

	const endContent = (() => {
		if (isCurrentDynamic) {
			return dynamicSlippageString ? `${dynamicSlippageString}%` : '';
		}

		return `${currentValue}%`;
	})();

	return (
		<TradeFormCollapsible
			localStorageKey="slippageToleranceExpanded"
			label={`Slippage ${isCurrentDynamic ? '(Dynamic)' : ''}`}
			endContent={endContent}
			contentClassName="mt-xs"
		>
			<ControlledSlippageToleranceInput
				className={className}
				optionsClassName={optionsClassName}
				handleCustomInputChange={handleCustomInputChange}
				handlePresetClick={handlePresetClick}
				presetOptions={presetOptions}
				customInputValue={customInputValue}
				isCustomInputFocused={isCustomInputFocused}
				handleBlur={handleBlur}
				handleFocus={handleFocus}
				currentValue={currentValue}
				isCurrentDynamic={isCurrentDynamic}
				hideCustom={hideCustom}
				hideDynamic={hideDynamic}
				disabled={disabled}
			/>
		</TradeFormCollapsible>
	);
};

export default React.memo(CollapsibleSlippageToleranceInput);
